import { Plus } from '@phosphor-icons/react';
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from 'core/components';
import { useAgGridClientTableContext } from 'core/states';
import { IComponentTemplate, IElementTemplate } from 'elements/types';
import { Color, Variant } from 'theme/enums';

import { AddLine } from './AddLine';

interface IProps {
  elementTemplate: IElementTemplate;
}

export const AddLineButton = ({ elementTemplate }: IProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const { t } = useTranslation();

  const { updateRows } = useAgGridClientTableContext();

  const onSubmitSuccess = useCallback(
    (part: IComponentTemplate) => {
      updateRows({ add: [part] });
    },
    [updateRows]
  );

  return (
    <>
      <Button
        text={t('buttonLabelAddLine')}
        color={Color.SUCCESS}
        variant={Variant.SOLID}
        startDecorator={<Plus />}
        onClick={() => setIsOpen(true)}
      />

      <AddLine
        elementTemplate={elementTemplate}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        onSubmitSuccess={onSubmitSuccess}
      />
    </>
  );
};
